import styled from 'styled-components';

export const InputsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 20px;
`;
